import { render } from "./UserExpenses.vue?vue&type=template&id=16c305ad&scoped=true&ts=true&lang=pug"
import script from "./UserExpenses.vue?vue&type=script&lang=ts"
export * from "./UserExpenses.vue?vue&type=script&lang=ts"

import "./UserExpenses.vue?vue&type=style&index=0&id=16c305ad&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c305ad"]])

export default __exports__